import React, { ButtonHTMLAttributes } from 'react';
import cn from 'classnames';

import styles from './button-link.module.scss';

interface IButtonLinkProps extends Partial<ButtonHTMLAttributes<HTMLButtonElement>> {
  onClick?: () => void;
  children: any;
  className?: string;
}

export default function ButtonLink({
  children,
  onClick,
  type = 'button',
  className,
  ...rest
}: IButtonLinkProps) {
  return (
    <button
      type={type}
      className={cn(styles['ag-button-link'], className)}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}
